<section class="content-header">
  <div class="container-fluid">
    <div class="card  ">
      <div class="card-header">
        <h5>
          <b>{{ "historical" | translate }}</b>
        </h5>

        <!-- New button -->
        <app-material-panel-menu
          [onlyButton]="true"
          [icon]="newIcon"
          [title]="newTitle"
          (action)="newActivation()"
        >
        </app-material-panel-menu>
      </div>

      <div class="card-body">
        <!-- Historical activations table -->
        <app-table-controller
          [tableId]="'activationHistorical'"
          [columns]="columns"
          [rowNumbers]="true"
          [maxReg]="20"
          [data]="tableData"
        >
        </app-table-controller>
      </div>
    </div>
  </div>
</section>
